import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { PopupEventType } from '../../../../../type/offer_type';

@Component({
  selector: 'app-coupon-tip',
  templateUrl: './coupon-tip.component.html',
  styleUrls: ['./coupon-tip.component.scss'],
})
export class CouponTipComponent implements OnInit {
  @Input() parent!: any;
  @Input() sliderWrapper!: boolean;
  @Input() shouldWrap: boolean = true;

  @Output() popupEvent = new EventEmitter<PopupEventType>();

  constructor() {}

  ngOnInit(): void {}

  mouseEvent(value: PopupEventType): void {
    this.popupEvent.emit(value);
  }
}
